"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const jwtDecode = require("jwt-decode");
const configureStore_1 = require("./configureStore");
const ListPage_1 = require("./views/home/ListPage");
const Environment_1 = require("./Environment");
const store = configureStore_1.default();
class Root extends React.PureComponent {
    componentWillMount() {
        const judoToken = Environment_1.getJudoTokenFromURL();
        if (judoToken) {
            try {
                const jwtDecoded = jwtDecode(judoToken);
                sessionStorage.setItem(Environment_1.JUDO_SESSION_KEY, JSON.stringify({ token: judoToken, userId: jwtDecoded.sub }));
            }
            catch (e) {
                if (!Environment_1.isRunningInIframe()) {
                    window.location.replace('/auth/sign-in');
                }
            }
        }
        else {
            window.addEventListener('storage', (event) => {
                if (event.key === 'ember_simple_auth:session' && !this.getToken() && !Environment_1.isRunningInIframe()) {
                    window.location.replace('/auth/sign-in');
                }
            });
        }
    }
    getToken() {
        const session = JSON.parse(localStorage.getItem('ember_simple_auth:session'));
        return session ? session.authenticated.token : null;
    }
    render() {
        return (React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(react_router_dom_1.BrowserRouter, null,
                React.createElement("div", { style: { height: '100%', width: '100%' } },
                    React.createElement(react_router_dom_1.Route, { path: "/campaigns/", component: ListPage_1.default })))));
    }
}
exports.default = Root;
